import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const CountdownTimer = ({ endTime, className = "", onExpire }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = new Date(endTime) - new Date();
    
    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    } else {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      
      // Check if timer has expired
      if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && 
          newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        if (onExpire) onExpire();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime, onExpire]);

  const formatTime = (time) => {
    return time.toString().padStart(2, '0');
  };

  const isExpired = timeLeft.days === 0 && timeLeft.hours === 0 && 
                   timeLeft.minutes === 0 && timeLeft.seconds === 0;

  if (isExpired) {
    return (
      <div className={`inline-flex items-center space-x-2 text-red-600 ${className}`}>
        <Clock size={16} />
        <span className="font-medium">Offer Expired</span>
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center space-x-2 ${className}`}>
      <Clock size={16} className="text-orange-500" />
      <div className="flex items-center space-x-1 font-mono font-bold">
        {timeLeft.days > 0 && (
          <>
            <span className="bg-orange-500 text-white px-2 py-1 rounded text-sm">
              {formatTime(timeLeft.days)}
            </span>
            <span className="text-orange-500 text-sm">d</span>
          </>
        )}
        <span className="bg-orange-500 text-white px-2 py-1 rounded text-sm">
          {formatTime(timeLeft.hours)}
        </span>
        <span className="text-orange-500 text-sm">:</span>
        <span className="bg-orange-500 text-white px-2 py-1 rounded text-sm">
          {formatTime(timeLeft.minutes)}
        </span>
        <span className="text-orange-500 text-sm">:</span>
        <span className="bg-orange-500 text-white px-2 py-1 rounded text-sm">
          {formatTime(timeLeft.seconds)}
        </span>
      </div>
      <span className="text-orange-500 text-sm font-medium">left</span>
    </div>
  );
};

export default CountdownTimer;